import { StateCreator } from 'zustand';

import { hasBasket } from '@utils/routing';
import { type Store } from '~/src/store/types';

const JOURNEY_MODE = {
  RESOLVING: 'RESOLVING',
  SIGNUP: 'SIGNUP',
  INLIFE: 'INLIFE',
} as const;

type JourneyMode = (typeof JOURNEY_MODE)[keyof typeof JOURNEY_MODE];

interface JourneyStore {
  mode: JourneyMode;
  setMode: (mode: JourneyMode) => void;
}

const createJourneyStoreSlice: StateCreator<Store, [], [], JourneyStore> = (
  set
) => ({
  mode: hasBasket() ? JOURNEY_MODE.RESOLVING : JOURNEY_MODE.SIGNUP,
  setMode: (mode) => set({ mode }),
});

export { createJourneyStoreSlice, JOURNEY_MODE };
export type { JourneyStore, JourneyMode };
